import { useRef, useState } from "react";
import {
    Button,
    FileField,
    FileInput,
    Form,
    useCreate,
    useNotify,
    useTranslate,
} from "react-admin";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { FileInformationManager } from "./fileInfoManagement/FileInformationManager";
import { FileManagerContextProvider } from "./fileInfoManagement/FileManagerContext";
import { handleHttpError } from "shared/src/utils/errorHandler";
import { ConfirmationDialog } from "shared/src/components/dialogs/ConfirmationDialog";

export const ExtractButton = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [arrival, setArrival] = useState(null);
    const [media, setMedia] = useState(null);
    const [create] = useCreate();
    const translate = useTranslate();
    const notify = useNotify();
    const submitRef = useRef(null);

    const handleButtonClick = (event) => {
        event.preventDefault();
        setIsDialogOpen(true);
    };

    const handleFileChange = (inputData) => {
        setIsUploading(true);
        const file = inputData.files;
        if (file) {
            notify(translate("equip.extraction.selectedFile", {
                fileName: file.rawFile.name,
            }));
            create(
                "arrivals",
                {
                    data: {
                        quantity: 0,
                        defect_quantity: 0,
                        purchase_price: 0,
                    },
                },
                {
                    onSuccess: (data) => {
                        setArrival(data);
                        create(
                            "media",
                            {
                                data: {
                                    arrival: data.id,
                                    public: true,
                                    shortname: inputData.shortname
                                        ? inputData.shortname
                                        : file.title,
                                    type: "file",
                                    mimetype: file.rawFile.type,
                                    size: file.rawFile.size,
                                    files: [file],
                                },
                            },
                            {
                                onSuccess: (data) => {
                                    setMedia(data);
                                    setIsUploading(false);
                                    setIsDialogOpen(false);
                                },
                                onError: (e) => {
                                    handleHttpError(e, notify);
                                },
                            }
                        );
                    },
                    onError: (e) => {
                        handleHttpError(e, notify);
                    },
                }
            );
        }
    };

    const handleCloseModal = () => {
        setMedia(null);
        setArrival(null);
    };

    return (
        <>
            <ConfirmationDialog
                open={isDialogOpen}
                label={translate("equip.chooseFileToExtract")}
                confirmButton={false}
                onCancel={() => setIsDialogOpen(false)}
                content={
                    <Form onSubmit={handleFileChange}>
                        <FileInput
                            source="files"
                            title={translate("equip.allowedFileTypes")}
                            label="equip.allowedFileTypes"
                            accept={{
                                "application/pdf": [".pdf"],
                            }}
                            multiple={false}
                            maxSize={209715200}
                            required
                            sx={{ p: 3 }}
                            onChange={() => submitRef.current.click()}
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                        <button type="submit" ref={submitRef} style={{ display: "none" }} />
                    </Form>
                }
            />
            <Button
                onClick={handleButtonClick}
                label={translate("equip.extract")}
                title={translate("equip.extract")}
                color={"primary"}
                startIcon={<UploadFileIcon />}
            />
            <FileManagerContextProvider
                arrival={arrival}
                media={media}
                isUploading={isUploading}
                onClose={handleCloseModal}
            >
                <FileInformationManager
                    media={media}
                    isUploading={isUploading}
                    onClose={handleCloseModal}
                />
            </FileManagerContextProvider>
        </>
    );
};
